import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StandardStatisticsData, OfferStatisticsData } from '../../models/statistics';

@Injectable({
  providedIn: 'root'
})
export class OrderOfferStatisticsService {
  protected http = inject(HttpClient);

  protected buildBody(productId: string): { required: { productId: string[] } } {
    return { required: { productId: [productId] } };
  }

  getOrderStatistics(productId: string): Observable<StandardStatisticsData[]> {
    return this.http.post<StandardStatisticsData[]>('json/order-statistics-nostream', this.buildBody(productId));
  }

  getOfferStatistics(productId: string): Observable<OfferStatisticsData[]> {
    return this.http.post<OfferStatisticsData[]>('json/offer-statistics-nostream', this.buildBody(productId));
  }
}
